module.exports = __webpack_public_path__ + "distVue/img/sjm_logo2.b02c0eed.png";